import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3418d0c0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "col-12 px-0" }
const _hoisted_2 = { class: "d-flex align-items-center" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "icon mr-2 icon-editieren",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_4 = { class: "w-100" }
const _hoisted_5 = { class: "col-12 col-md-6 offset-md-3 mt-4 px-xs-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_link_back = _resolveComponent("link-back")!
  const _component_control_select = _resolveComponent("control-select")!
  const _component_control_input = _resolveComponent("control-input")!
  const _component_control_checkbox = _resolveComponent("control-checkbox")!
  const _component_button_save = _resolveComponent("button-save")!
  const _component_loading_container = _resolveComponent("loading-container")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h1", _hoisted_2, [
        _hoisted_3,
        _createTextVNode(" " + _toDisplayString(_ctx.$t('views.timeSlotBook.title')), 1)
      ])
    ]),
    _createVNode(_component_link_back, {
      to: { name: 'admin-time-slot-edit', params: { roomId: _ctx.roomId, timeSlotId: _ctx.timeSlotId } },
      i18nMessage: "common.backToTimeSlot",
      class: "mt-2"
    }, null, 8, ["to"]),
    _createVNode(_component_loading_container, { state: _ctx.state }, {
      default: _withCtx(() => [
        _createElementVNode("form", {
          onSubmit: _cache[8] || (_cache[8] = _withModifiers(($event: any) => (_ctx.onSubmit()), ["prevent"]))
        }, [
          _createElementVNode("dl", _hoisted_4, [
            _createElementVNode("dt", null, _toDisplayString(_ctx.$t('views.timeSlotBook.room')), 1),
            _createElementVNode("dd", null, _toDisplayString(_ctx.room.name || ''), 1),
            _createElementVNode("dt", null, _toDisplayString(_ctx.$t('views.timeSlotBook.dateTime')), 1),
            _createElementVNode("dd", null, _toDisplayString(_ctx.timeSlotDateFormatted || ''), 1)
          ]),
          _createVNode(_component_control_select, {
            i18nLabel: "common.owner.salutation",
            validation: _ctx.v$.salutation,
            modelValue: _ctx.salutation,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.salutation) = $event)),
            availableValues: _ctx.salutationOptions()
          }, null, 8, ["validation", "modelValue", "availableValues"]),
          _createVNode(_component_control_input, {
            i18nLabel: "common.owner.title",
            validation: _ctx.v$.title,
            modelValue: _ctx.title,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.title) = $event))
          }, null, 8, ["validation", "modelValue"]),
          _createVNode(_component_control_input, {
            i18nLabel: "common.owner.givenName",
            validation: _ctx.v$.givenName,
            modelValue: _ctx.givenName,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.givenName) = $event))
          }, null, 8, ["validation", "modelValue"]),
          _createVNode(_component_control_input, {
            i18nLabel: "common.owner.surName",
            validation: _ctx.v$.surName,
            modelValue: _ctx.surName,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.surName) = $event))
          }, null, 8, ["validation", "modelValue"]),
          _createVNode(_component_control_input, {
            i18nLabel: "common.owner.organization",
            validation: _ctx.v$.organization,
            modelValue: _ctx.organization,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.organization) = $event))
          }, null, 8, ["validation", "modelValue"]),
          _createVNode(_component_control_input, {
            i18nLabel: "common.owner.email",
            validation: _ctx.v$.email,
            modelValue: _ctx.email,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.email) = $event)),
            type: "email"
          }, null, 8, ["validation", "modelValue"]),
          _createVNode(_component_control_input, {
            i18nLabel: "common.owner.phone",
            validation: _ctx.v$.phone,
            modelValue: _ctx.phone,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.phone) = $event)),
            type: "tel"
          }, null, 8, ["validation", "modelValue"]),
          _createVNode(_component_control_checkbox, {
            i18nLabel: "common.owner.accessible",
            validation: _ctx.v$.accessible,
            modelValue: _ctx.accessible,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.accessible) = $event))
          }, null, 8, ["validation", "modelValue"]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_button_save, {
              i18nMessage: "views.timeSlotBook.book",
              class: "btn-w-100"
            })
          ])
        ], 32)
      ]),
      _: 1
    }, 8, ["state"])
  ]))
}